<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconKey_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M10.25 2C8.18 2 6.5 3.68 6.5 5.75c0 .24 0 .48.045.705L2 11v3h4.5v-3h3V9.5l.045-.045c.225.045.465.045.705.045C12.32 9.5 14 7.82 14 5.75 14 3.68 12.32 2 10.25 2ZM11 3.5c.825 0 1.5.675 1.5 1.5s-.675 1.5-1.5 1.5S9.5 5.825 9.5 5s.675-1.5 1.5-1.5Z"
    />
</svg>
